import { Col, Row } from "antd";
import { SecondaryButton } from "../CustomButtons/CustomButtons";
import { useLocation } from "react-router-dom";
import { useVolSurfaceControlTable } from "contexts/VolSurfaceControlTableContext";

export default function SaveVolSurface({
  dark_Theme,
  selectedFilters,
  disabledGraphControl,
  onUpdateGraphTitle,
}) {
  const location = useLocation();
  const { stickyStrikeData, lockedData } = useVolSurfaceControlTable();

  const pathName = location.pathname;
  const isVolSurfacePage = pathName.includes("vol-surface");
  const hideDateFilterOnProdForVolSurface = !isVolSurfacePage;
  return (
    <Col span={24}>
      <Row gutter={[25, 25]}>
        <Col span={3}>Vol Surface: </Col>
        <Col>
          <SecondaryButton
            // className={dark_Theme ? "graph-btn" : ""}
            disabled={
              lockedData?.is_locked ||
              !selectedFilters["product_id"] ||
              disabledGraphControl ||
              (stickyStrikeData?.is_surface_locked &&
                !hideDateFilterOnProdForVolSurface)
            }
            onClick={() => onUpdateGraphTitle()}
          >
            Save
          </SecondaryButton>
        </Col>
      </Row>
    </Col>
  );
}
